import { EAppAction, EAppState, IAppState, TAppAction } from "../../types"

export const appInitialState: IAppState = {}

export const appReducer = (state = appInitialState, action: TAppAction) => {
    switch (action.type) {
        case EAppAction.SET_INFO_MESSAGE:
            return { ...state, [EAppState.SET_INFO_MESSAGE]: action.payload }
        case EAppAction.SET_TOKEN:
            return { ...state, [EAppState.SET_TOKEN]: action.payload }
        default:
            return state
    }
}